export const authTokenKey = 'authToken';
